import { gql } from "@apollo/client";

const Fragments = {
  listQuoteItem: gql`
    fragment listQuoteItem on ListQuoteItem {
      quoteId
      userId
      oldActionName
      lastActionAgo
      productType
      taxID
      statusColorCode
      nextActionId
      nextActionName
      scheduleIsConfigurable
      quote {
        quoteId
        transactionId
        quoteStatusId
        quoteStatusName
        partnerName
        estimationName
        isEstimation
        city
        district
        totalAssetNetPrice
        dealerId
        vendorId
        assetNo
        downPayment
        period
        zootDocDecisionFinished
        zootDocDecisionColor
      }
    }
  `,
};

export default Fragments;
